// extracted by mini-css-extract-plugin
export default {"inputMenuItem":"BaseSelect_inputMenuItem__Vegn0","error":"BaseSelect_error__1SJS4"};